/**
 * Prefer the backend HubReconcileResponseDto.message (or common error shapes).
 */
export const getApiMessage = (payload, fallback = "Something went wrong") => {
  if (!payload) return fallback;
  if (typeof payload === "string") return payload;

  return (
    payload.message ||
    payload?.data?.message ||
    payload?.response?.data?.message ||
    payload?.error?.message ||
    fallback
  );
};
